import React, { useState } from 'react'
import { Button, Dropdown } from 'antd'
import { DownloadOutlined } from '@ant-design/icons'
import { useParams } from 'react-router'
import { useLazyExportEscalatedSubmissionsQuery } from '../../../../../../store/apis/assignment.api'
import fileDownload from 'js-file-download'
import { openNotificationWithIcon } from '../../../../../../utils/notification.helper'

const ExportEscalatedSubmissionsButton = () => {
    const { token } = useParams()
    const [exportEscalatedSubmissions, { isFetching }] = useLazyExportEscalatedSubmissionsQuery()

    const handleExport = async includeAllHistory => {
        try {
            const response = await exportEscalatedSubmissions({ token, includeAllHistory })
            if ('data' in response) {
                const timestamp = new Date().toISOString().split('T')[0]
                const filename = includeAllHistory
                    ? `escalated_submissions_all_${timestamp}.csv`
                    : `escalated_submissions_current_${timestamp}.csv`
                fileDownload(response.data, filename)
                openNotificationWithIcon('success', 'Export completed successfully')
            } else {
                openNotificationWithIcon('error', response.error?.data?.message || 'Export failed')
            }
        } catch (error) {
            openNotificationWithIcon('error', 'An error occurred during export')
        }
    }

    const menuItems = [
        {
            key: 'current',
            label: 'Currently escalated',
            onClick: () => handleExport(false),
        },
        {
            key: 'all',
            label: 'All history (including resolved)',
            onClick: () => handleExport(true),
        },
    ]

    return (
        <Dropdown menu={{ items: menuItems }} trigger={['click']} placement='bottomRight'>
            <Button type='text' icon={<DownloadOutlined />} loading={isFetching} title='Export escalated submissions'/>
        </Dropdown>
    )
}

export default ExportEscalatedSubmissionsButton

